<template>
  <div class="f_right">
    <h2>物流情况</h2>
    <div class="logistics">
      <ul class="express">
        <li class="item" v-for="(item, index) in singles" :key="index">
          <div>
            <div class="logn_header">
              <div class="logn"></div>
              <div class="message">
                <p>
                  物流单号: <span> {{ singles[index] }}</span>
                </p>
                <p>
                  收货人: <span>{{ peoples[index] }}</span>
                </p>
              </div>
            </div>
            <div class="express_footer">
              <ul class="express_title">
                <li class="express_li">时间</li>
                <li class="express_li">地点和跟踪进度</li>
              </ul>
              <div class="particulars">
                <div
                  class="particulars_message"
                  v-for="(item2, i) in expressArr[index]"
                  :key="i"
                >
                  <ul>
                    <li>{{ item2.time }}</li>
                    <li class="line">
                      <div :class="{ active: i === 0 }" class="circle"></div>
                    </li>
                    <li>{{ item2.description.substring(0, 3) }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fright",
  data() {
    return {
      singles: [],
      peoples: [],
      width: 0,
      index: 0,
      expressArr: [], //快递详情的数组
    };
  },
  created() {
    this.$axios
      .get(`${this.$url}/admin/bigpin11`)
      .then((res) => {
        let datas = JSON.parse(res.data.split("<\/script>")[1]).data;

        this.singles = datas.rows.map((item) => item[1]);
        this.peoples =datas.rows.map((item) => item[0]);
        setInterval(() => {
          this.scroll();
        }, 2000);
        return new Promise((res, rej) => {
          res(this.singles);
        });
      })
      .then((data) => {
        this.$axios
          .get(`http://cs.lcyjfz.com/api/DBTrace?number=${data.join(",")}`)
          .then((res) => {
            this.expressArr = res.data.data.map((item) => item.trace_list);
          });
      });
  },
  methods: {
    scroll() {
      let itemWidth = document.querySelectorAll(".logistics li")[0].clientWidth;
      let list = document.querySelectorAll(".logistics > ul")[0];
      if (this.index >= this.singles.length - 1) {
        this.width = 0;
        this.index = -1;
      }
      this.width += itemWidth;
      list.style.transform = `translate(-${this.width}px,0)`;
      this.index++;
    },
  },
};
</script>

<style lang="less" scoped>
.f_right {
  width: 100%;
  height: 100%;
  h2 {
    color: rgb(14, 242, 245);
    font-size: 1.25rem;
    margin-left: 3.125rem;
    padding: 1rem 0;
  }
  .logistics {
    height: 50%;
    background: url("~@/assets/image/框E.png") no-repeat;
    background-size: 100% 100%;
    padding: 0.625rem;
    overflow: hidden;
    .express {
      display: flex;
      height: 100%;
      transition: all 2s;
      .item {
        flex-shrink: 0;
        width: 25%;
        height: 100%;
        margin: 0 0.625rem;
        overflow: hidden;
        & > div {
          height: 100%;
          .logn_header {
            background: url("~@/assets/image/框F上.png") no-repeat;
            background-size: 100% 100%;
            height: 30%;
            display: flex;
            .logn {
              width: 30%;
              height: 100%;
              background: url("~@/assets/image/图标F物流.png") center no-repeat;
              background-size: 50% 50%;
            }
            .message {
              width: 70%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              font-size: 0.5rem;
            }
          }
          .express_footer {
            height: 70%;
            background: url("~@/assets/image/框F下.png") no-repeat;
            background-size: 100% 100%;
            width: 100%;
            .express_title {
              display: flex;
              justify-content: space-between;
              text-align: left;
              padding-top: 0.625rem;
              width: 100%;
              .express_li {
                margin: 0 0.625rem;
              }
            }
            .particulars {
              width: 100%;
              .particulars_message > ul {
                display: flex;
                justify-content: space-between;
                text-align: center;
                font-size: 0.75rem;
                li {
                  height: 1.5rem;
                  line-height: 1.5rem;
                  position: relative;
                }
              }
            }
          }
        }
      }
    }
  }
}
.active {
  background-color: rgb(13, 253, 255) !important;
}
.circle {
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  position: relative;
  z-index: 999;
  background-color: white;
}
.line::after {
  content: "|";
  width: 0.125rem;
  background-color: white;
  height: 30%;
  position: absolute;
  bottom: 0;
  left: 40%;
}
</style>